import { Instance } from 'mobx-state-tree';
import { ShopifyOrderDtoModelBase } from './ShopifyOrderDtoModel.base';

/* The TypeScript type of an instance of ShopifyOrderDtoModel */
export interface ShopifyOrderDtoModelType extends Instance<typeof ShopifyOrderDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyOrderDtoModel */
export { selectFromShopifyOrderDto, shopifyOrderDtoModelPrimitives, ShopifyOrderDtoModelSelector } from './ShopifyOrderDtoModel.base';

/**
 * ShopifyOrderDtoModel
 */
export const ShopifyOrderDtoModel = ShopifyOrderDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
